import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import Select from 'react-select'
import 'react-dropdown/style.css'
import update from 'immutability-helper'
import RowRenderer from './InlineEditingRowRenderer.js'
import '../../../css/style.css'
import config from '../../../resource/constants.js'
import InlineEditingSaveBtn from '../../../components/buttons/InlineEditingSaveBtn'
import validationFuncs from './validationFuncs'
const ReactDataGrid = require('react-data-grid')
const { Data: { Selectors } } = require('react-data-grid-addons')
const _ = require('lodash')



class InlineEditingGridData extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = { data: 'false',
                   errorColumns: 'false',
                   errorCategories: 'false',
                   isLoading: true,
                   selectedCol: '',
                   selectedCategory: '',
                   errorTypeDesc: '',
                   selectedIndexes: [],
                   selectedRecordNumbers: []
                 }
    this.handleColumnChange = this.handleColumnChange.bind(this)
    this.handleCategoryChange = this.handleCategoryChange.bind(this)
    this.changeSaveButtonState = this.changeSaveButtonState.bind(this)
  }

  componentDidMount() {
    const sortedErrorColumns = this.sortErrorColumns(this.props.errorColumns)
    const newColumns = this.injectAttributesForDuplicates(this.props.columns)
    this.setState({ data: this.props.data })
    this.setState({ rows: this.props.data})
    this.setState({ errorColumns:  sortedErrorColumns })
    this.setState({ defaultColumns: this.props.defaultColumns })
    this.setState({ defaultDupColumns: this.props.defaultDupColumns })
    this.setState({ defaultMergedColumns: this.props.defaultMergedColumns})
    this.setState({ errorCategories:  this.props.errorCategories })
    this.setState({ errorCategoriesData:  this.props.errorCategories })
    this.setState({ totalErrors:  this.props.totalErrors })
    this.setState({ columnsData:  this.props.columns })
    this.setState({ columns:  newColumns })
    this.setState({ selectedCol: '' })
    this.setState({ selectedCategory: '' })
    this.setState({ attributeTotalErrors: ''})
    this.setState({ isLoading: false })
    this.setState({ hideGrid: true })
    this.setState({ disableSaveBtn: true })
    this.setState({ hideCategoryFilter: true })
    this.setState({ deletedRecords: [] })
    this.setState({ validationMetaData: this.props.validationMetaData })
    this.initGridWithFirstColumn(sortedErrorColumns[0])
  }

  componentDidUpdate(){
    const errorCells = ReactDOM.findDOMNode(this).getElementsByClassName('inline_editing_error_cell')
    for(let cell of errorCells){
      cell.setAttribute('tabIndex', '0')
    }
  }


  setColumnsWidth(columns) {
    const gridWidth = 1142  //this looks like default size of grid
    let combinedColumnWidth = 0
    let hasDuplicate = false
    for (let col of columns) {
      hasDuplicate = Object.values(col).includes('DUPLICATE')
    }
    for (let i = 0; i < columns.length; i++) {
      columns[i].width = this.getTextWidth(columns, i, hasDuplicate)
      combinedColumnWidth += columns[i].width
    }
    //console.log("combinedColumnWidth ", combinedColumnWidth)
    if (combinedColumnWidth < gridWidth) {
      columns = this.distributeRemainingSpace(
        combinedColumnWidth,
        columns,
        gridWidth
      )
    }
    return columns
  }

  getTextWidth(columns, i, scroll) {
    const cellPadding = 6,
          arrowWidth = 2,
          scrollCellPadding = 20,
          scrollArrowWidth = 15
    let longestColName,
      longestColNameWidth
    longestColName = columns[i].name
    longestColNameWidth = Math.ceil(this.getCanvas("bold").measureText(longestColName).width) + (scroll ? scrollArrowWidth : arrowWidth)
    return longestColNameWidth + (scroll ? scrollCellPadding : cellPadding)
  }

  getCanvas(fontWeight = "") {
    if (!this.canvas) {
      this.canvas = document.createElement("canvas")
      this.canvasContext = this.canvas.getContext("2d")
    }
    this.canvasContext.font = `bold 11.5px Roboto,sans-serif`
    return this.canvasContext
  }

  distributeRemainingSpace(combinedColumnWidth, columns, gridWidth) {
    const spaceLeftOver = gridWidth - combinedColumnWidth
    const remainder = spaceLeftOver % columns.length
    const equalSpaceLeft = spaceLeftOver - remainder
    columns[0].width += remainder //any remaining space after distributing equally should go on first column
    for (let col of columns) {
        col.width += equalSpaceLeft / columns.length
    }
    return columns
  }

  sortErrorColumns(errorColumns) {
      let indexObject = _.reduce(errorColumns, function(result, currentObject) {
            result[currentObject.value] = currentObject
            return result
            }, {})
      const sortedColumns = _.filter(_.map(config.file_column_headers, currentValue => {
        return indexObject[currentValue]
      }), item => item !== undefined)
      return sortedColumns
  }

  initGridWithFirstColumn(option) {
      let filteredDataByCol = this.filterDataByInitialColumn(option)
      let selectedCategory = ''
      let errorTypeDesc = ''
      selectedCategory = filteredDataByCol.filteredCategories[0]
      const errors = filteredDataByCol.filteredRows[0].ERRORS

      errors.forEach(error => {
          if (error.ATTRIBUTE_NAME === option.value) {
            errorTypeDesc = error.RECORD_TYPE === 'E' ? error.ERRORS[0].DESCRIPTION : error.WARNING
          }
      })
      this.setState({
          selectedCol: option,
          selectedCategory: selectedCategory,
          hideCategoryFilter: option.value === 'DUPLICATE' ? true : false,
          columns: this.setColumnsWidth(filteredDataByCol.filteredColumns),
          errorCategories: filteredDataByCol.filteredCategories,
          rows: filteredDataByCol.filteredRows,
          totalErrors:filteredDataByCol.filteredRows.length,
          attributeTotalErrors: this.props.totalErrorsMap[option.value],
          errorTypeDesc: errorTypeDesc,
          hideGrid: false
      })
      if(option.value !== 'DUPLICATE')
        this.handleCategoryChange(selectedCategory)
      this.forceUpdate()
  }

  filterDataByInitialColumn(selectedColumn) {
    this.setState({
      errorCategories: this.props.errorCategories,
      selectedCategory: '',
      errorTypeDesc: ''
    })
    let columnsToBeFiltered = this.props.columns
    let defaultCols = []
    if(selectedColumn.value === 'DUPLICATE') {
      defaultCols = this.props.defaultDupColumns.map(col => col.value)

    } else {
      let defaultColumns = this.props.defaultColumns.map(col => col.value)
      defaultCols = config.extended_default_cols[selectedColumn.value] ? defaultColumns.concat(config.extended_default_cols[selectedColumn.value]) : defaultColumns
    }
    let filteredColumns = columnsToBeFiltered.filter(col => {
      if(selectedColumn.value === 'DUPLICATE'){
        return  _.includes(defaultCols, col.key)
      } else{
        return  _.includes(defaultCols, col.key) || col.key === selectedColumn.value
      }

    })
    let rows = this.props.data
    let filteredRows = []
    let errorCategoriesInFilteredRows = []
    rows.forEach(row => {
      row.ERRORS.forEach(error => {
        if(error.ATTRIBUTE_NAME === selectedColumn.value){
          filteredRows.push(row)
          if(error.RECORD_TYPE === 'E'){
            error.ERRORS.forEach(msg => {
              errorCategoriesInFilteredRows.push(msg.CATEGORY)
            })
          } else if(error.RECORD_TYPE === 'W') {
            errorCategoriesInFilteredRows.push(error.CATEGORY)
          }
        }
      })
    })
    if (selectedColumn.value === 'DUPLICATE') {
       filteredRows.sort((a, b) => (a.DUP_RECORDS.toString() > b.DUP_RECORDS.toString()) ? 1 : ((b.DUP_RECORDS.toString() > a.DUP_RECORDS.toString()) ? -1 : 0))
    }
    let allCateogries = this.props.errorCategories
    let filteredCategories = allCateogries.filter(cat => _.includes(errorCategoriesInFilteredRows, cat.value))
    let attributeTotalErrors = this.props.totalErrorsMap[selectedColumn.value]
    return { filteredColumns, filteredRows, filteredCategories, attributeTotalErrors }
  }

  rowGetter = (index) => {
    return Selectors.getRows(this.state)[index]
  };

  rowsCount = () => {
    return Selectors.getRows(this.state).length
  };

  filterDataByColumn = (selectedColumn) => {
    //console.log('selectedColumn:', selectedColumn.value)
    this.setState({
      errorCategories: this.state.errorCategoriesData,
      selectedCategory: '',
      errorTypeDesc: ''
    })
    let columnsToBeFiltered = this.state.columnsData
    let defaultCols = []
    if(selectedColumn.value === 'DUPLICATE') {
      defaultCols = this.state.defaultDupColumns.map(col => col.value)
    } else {
      let defaultColumns = this.state.defaultColumns.map(col => col.value)
      defaultCols = config.extended_default_cols[selectedColumn.value] ? defaultColumns.concat(config.extended_default_cols[selectedColumn.value]) : defaultColumns
    }
    //console.log("Extended Columns: ", config.extended_default_cols[selectedColumn.value])
    let filteredColumns = columnsToBeFiltered.filter(col => {
      // this is where you can remove the DUPLICATE field from being displayed!!
      if(selectedColumn.value === 'DUPLICATE'){
        return  _.includes(defaultCols, col.key)
      } else{
        return  _.includes(defaultCols, col.key) || col.key === selectedColumn.value
      }
    })
    let rows = this.state.data
    let filteredRows = []
    let errorCategoriesInFilteredRows = []
    rows.forEach(row => {
      row.ERRORS.forEach(error => {
        if(error.ATTRIBUTE_NAME === selectedColumn.value){
          filteredRows.push(row)
          if(error.RECORD_TYPE === 'E'){
            error.ERRORS.forEach(msg => {
              errorCategoriesInFilteredRows.push(msg.CATEGORY)
            })
          } else if(error.RECORD_TYPE === 'W') {
            errorCategoriesInFilteredRows.push(error.CATEGORY)
          }
        }
      })
    })
    if (selectedColumn.value === 'DUPLICATE') {
       filteredRows.sort((a, b) => (a.DUP_RECORDS.toString() > b.DUP_RECORDS.toString()) ? 1 : ((b.DUP_RECORDS.toString() > a.DUP_RECORDS.toString()) ? -1 : 0))
   }
   let allCateogries = this.state.errorCategoriesData
   let filteredCategories = allCateogries.filter(cat => _.includes(errorCategoriesInFilteredRows, cat.value))
   let attributeTotalErrors = this.props.totalErrorsMap[selectedColumn.value]
   return { filteredColumns, filteredRows, filteredCategories, attributeTotalErrors }
   }

   injectAttributesForDuplicates = (columns) => {
       let newCols = columns.map(col => {
           let dupRecordsList = []
           let dupRecordsDataList = this.props.data.filter(e => e.DUP_RECORDS !== undefined)
           dupRecordsDataList.sort((a, b) => (a.DUP_RECORDS.toString() > b.DUP_RECORDS.toString()) ? 1 : ((b.DUP_RECORDS.toString() > a.DUP_RECORDS.toString()) ? -1 : 0))
           dupRecordsDataList.forEach(dataRow => {
               dupRecordsList.push(dataRow.DUP_RECORDS)
           })
           let dupRecordSet = _.uniqWith(dupRecordsList, _.isEqual)
           let index = 0
           col.rowColorGroups = _.groupBy(dupRecordSet, s => {
               const colorScale = ['inline_editing_duplicate_gray_cell', 'inline_editing_normal_cell']
               return colorScale[index === 0 ? index++ : index--]
           })
           col.sortable = false
           return col
       })
       return newCols
   }


  handleColumnChange(option) {
    const resizeEvent = document.createEvent("HTMLEvents")
    resizeEvent.initEvent('resize', true, false)
    window.dispatchEvent(resizeEvent)
    setTimeout(() => {  window.dispatchEvent(resizeEvent) }, 0)
    console.log("Starting handleColumnChange")
    let filteredDataByCol = this.filterDataByColumn(option)
    //console.log("in handleColumnChange ", option)
    let selectedCategory = ''
    let errorTypeDesc = ''

    selectedCategory = filteredDataByCol.filteredCategories[0]
    const errors = filteredDataByCol.filteredRows[0] ? filteredDataByCol.filteredRows[0].ERRORS : []
    errors.forEach(error => {
        if (error.ATTRIBUTE_NAME === option.value) {
          errorTypeDesc = error.RECORD_TYPE === 'E' ? error.ERRORS[0].DESCRIPTION : error.WARNING
        }
    })
    this.setState({
      selectedCol: option,
      selectedCategory: selectedCategory,
      hideCategoryFilter: option.value === 'DUPLICATE' ? true : false,
      columns: this.setColumnsWidth(filteredDataByCol.filteredColumns),
      errorCategories: filteredDataByCol.filteredCategories,
      rows: filteredDataByCol.filteredRows,
      totalErrors: filteredDataByCol.filteredRows.length,
      attributeTotalErrors: filteredDataByCol.attributeTotalErrors,
      errorTypeDesc: errorTypeDesc,
      hideGrid: false
    })
    if(option.value !== 'DUPLICATE')
      this.handleCategoryChange(selectedCategory)
  }

  filterDataByCategory = (selectedCategory) => {
    //console.log('selectedCategory:', selectedCategory)
    let filteredByCategory = []
    let errorTypeDesc = ''
    let selectedColumn = this.state.selectedCol
    //console.log('selectedColumn:', selectedColumn)
    if(!_.isEmpty(this.state.selectedCol)){
      let dataItems = this.state.data
      filteredByCategory = dataItems.filter(item => {
        let categories = []
        item.ERRORS.forEach(error => {
          if(error.ATTRIBUTE_NAME === selectedColumn.value){
            if(error.RECORD_TYPE === 'E'){
              error.ERRORS.forEach(msg => {
                if(_.isEmpty(errorTypeDesc) && msg.CATEGORY === selectedCategory.value){
                  errorTypeDesc = msg.DESCRIPTION
                }
                categories.push(msg.CATEGORY)
              })
            } else if(error.RECORD_TYPE === 'W'){
              if(_.isEmpty(errorTypeDesc) && error.CATEGORY === selectedCategory.value){
                errorTypeDesc = error.WARNING
              }
              categories.push(error.CATEGORY)
            }
          }
        })
        return categories.includes(selectedCategory.value)
      })
    }
    return {filteredByCategory, errorTypeDesc}
  }

  handleCategoryChange(option) {
    //console.log("in handleCategoryChange ", option)
    this.setState({selectedCategory: option},
      () => {
        let result = this.filterDataByCategory(option)
        this.setState({
          filteredByCategory: result.filteredByCategory,
          errorTypeDesc: result.errorTypeDesc
        },
          () => {
            this.setState({ rows: this.state.filteredByCategory })
            this.setState({ totalErrors: this.state.filteredByCategory.length })
            if(!_.isEmpty(this.state.selectedCol)){
              this.setState({ hideGrid: false})
            }
          }
        )
      }
    )
  }

  handleSubmit() {
    console.log('submitted action')
  }


changeSaveButtonState = () => {
  this.setState({disableSaveBtn: true})
}


  handleGridRowsUpdated = ({ cellKey, fromRow, toRow, updated, action, originRow }) => {
    let rows = this.state.rows
    let data = this.state.data
    //if user enters a number we need to parse it to a number since Data Grid retruns as a string
    if(!_.isEmpty(updated[cellKey]) && typeof updated[cellKey] === 'string' && !isNaN(updated[cellKey]) && updated[cellKey].length <= 16){
      updated[cellKey] = parseInt(updated[cellKey])
    }

    //validate user input
    let errors = this.generateValidationErrors(updated, cellKey)

    if(updated[cellKey] === ''){
      updated[cellKey] = null
    }
    for (let i = fromRow; i <= toRow; i++) {
      let rowToUpdate = rows[i]
      rowToUpdate[cellKey + '_UI_ERRORS'] = errors
      //putting the original value in a different filed (<field name> + _ORIGIN)
      if(rowToUpdate[cellKey + '_ORIGIN'] === undefined){
        rowToUpdate[cellKey + '_ORIGIN'] = rowToUpdate[cellKey] ? rowToUpdate[cellKey] : null
        rowToUpdate['ROW_UPDATED'] = true
      }
      let updatedRow = update(rowToUpdate, {$merge: updated})
      rows[i] = updatedRow
      data.forEach((item, index) => {
        if(item.RECORD_NUM === rowToUpdate.RECORD_NUM){
          item[cellKey + '_UI_ERRORS'] = errors
          if(item[cellKey + '_ORIGIN'] === undefined){
            item[cellKey + '_ORIGIN'] = item[cellKey] ? item[cellKey] : null
            item['ROW_UPDATED'] = true
          }
          let updatedItem = update(item, {$merge: updated})
          data[index] = updatedItem
        }
      })
    }
    this.setState({ rows, data, disableSaveBtn: false })
    window.onbeforeunload = () => true
  }

  generateValidationErrors = (updated, cellKey) => {
    const validationMetaData = this.state.validationMetaData
    const cellKeyMetaData = validationMetaData[cellKey]
    const required = cellKeyMetaData.required
    const name = cellKeyMetaData.name
    const rules = cellKeyMetaData.rules
    let errors = []

    if(updated[cellKey] === ''){
      if(required){
        errors.push(`${name} is a required field!`)
      }
    } else {
      rules.forEach(rule => {
        //console.log('rule:',rule)
        let isValid = validationFuncs.isValid(rule, updated[cellKey])
        if(!isValid){
          errors.push(rule.ERROR_MSG)
        }
      })
    }
    //console.log('validation errors:', errors)
    return errors
  }

  handleGridSort = (sortColumn, sortDirection) => {
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return (a[sortColumn] > b[sortColumn]) ? 1 : -1
      } else if (sortDirection === 'DESC') {
        return (a[sortColumn] < b[sortColumn]) ? 1 : -1
      }
    }
    const rows = sortDirection === 'NONE' ? this.state.rows.slice(0) : this.state.rows.sort(comparer)
    this.setState({ rows })
  }

  onRowsSelected = rows => {
    console.log("rows: " + JSON.stringify(rows))
    this.setState({
      selectedIndexes: this.state.selectedIndexes.concat(
        rows.map(r => r.rowIdx)
      )
    })
    const selectedRows = rows.map(r => r.row.RECORD_NUM)
    console.log(this.state.selectedRecordNumbers)
    let recordNum = selectedRows.pop()
    console.log("recordNum: " + recordNum)
    let changeData = this.state.data.slice()
    let deleteRecs = this.state.deletedRecords
    const matchDataRecord = changeData.filter(r => (r.RECORD_NUM === recordNum && !_.isEmpty(r.DUP_RECORDS)))
    console.log("matched data record: " + JSON.stringify(matchDataRecord))
    let matchedDeleteRecord = { requestId: matchDataRecord[0].REQUEST_ID,
                                recordId: matchDataRecord[0].RECORD_ID,
                                recordNum: matchDataRecord[0].RECORD_NUM,
                                originalId: matchDataRecord[0].ORIGINAL_ID,
                                dupId: matchDataRecord[0].DUP_ID
                              }
    deleteRecs.push(matchedDeleteRecord)
    this.setState({ deletedRecords: deleteRecs })
    this.setState({
      disableSaveBtn: false

    })
  }

  onRowsDeselected = rows => {
    let deleteRecs = this.state.deletedRecords
    let rowIndexes = rows.map(r => r.rowIdx)
    const deSelectedRows = rows[0].row.RECORD_NUM //rows.map(r => r.row.RECORD_NUM)
    console.log("deSelectedRows: " + typeof deSelectedRows)
    const dRecords = deleteRecs.filter(elem => elem.recordNum !== deSelectedRows)
      console.log(dRecords)
    this.setState({ deletedRecords: dRecords})
      this.setState({
        selectedIndexes: this.state.selectedIndexes.filter(
          i => rowIndexes.indexOf(i) === -1
        )
      })
      console.log("Hello!")
  }

  getRowSelection = () =>{
    const rowSelection = {
      showCheckbox: true,
      enableShiftSelect: true,
      onRowsSelected: this.onRowsSelected,
      onRowsDeselected: this.onRowsDeselected,
      selectBy: {
        indexes: this.state.selectedIndexes
      }
    }
      const rowSelectionNull = null


    if(this.state.selectedCol.value === "DUPLICATE"){
      return rowSelection
    } else{
      return rowSelectionNull
    }
  }

  render() {
    return  (
      this.state.isLoading ? <div role="progressbar" aria-valuetext="Loading…" className="cb-loader cb-loader-blue cb-loader-lg"></div> :
      <div>
          <p>Use ‘Column Name’ and ‘Error/Warning Type’ dropdowns to view the errors and warnings within your file.
            The text beneath the dropdowns provides information on the requirements for the data and the number of records with that specific error/warning.
            Update the error values shown in Red boxes.
            Continue to update error values for each Column Name and Error/Warning Type.
            Once you have fixed the errors/warnings, click the <b>Revalidate</b> button.</p>
        <div className="panel panel-summary">
          <div className="panel-heading">
          {!this.props.requestData.ORG_NAMES ? '' : <p id="orginization-description-inline-editing">Organization(s): {this.props.requestData.ORG_NAMES.join(', ')}</p>}
            <p id="request-status-description-inline-editing">Request Status: {this.props.requestData.REQ_STATUS}</p>
          </div>
          <div className="panel-body">
            <div className="col-md-12">
              <div className="row">
                <div className="form-group col-xs-4"id="column-name-dropdown-form">
                  <label htmlFor={this.state.selectedCol.value}>Column Name: </label>
                  <Select
                    defaultValue={this.state.errorColumns[0]}
                    value={this.state.selectedcol}
                    onChange={this.handleColumnChange}
                    options={this.state.errorColumns}
                    id={this.state.selectedCol.value}
                  />
                </div>
                <div hidden={this.state.hideCategoryFilter} className="form-group col-xs-4" id="error-type-dropdown-form">
                  <label htmlFor={this.state.selectedCategory.label}>Error/Warning Type:  </label>
                  <Select
                    defaultValue={this.state.selectedCategory}
                    value={this.state.selectedCategory}
                    onChange={this.handleCategoryChange}
                    options={this.state.errorCategories}
                    id={this.state.selectedCategory.label}
                  />
                </div>
              </div>
              <div className="error_type_description" id="error-type-description">
                <p>{this.state.errorTypeDesc}</p>
              </div>
              <div>
                {/* showing the total number just for errors, if there are more than 50 errors, for a specific attribute */}
                {(this.state.attributeTotalErrors > 50  && ((this.state.selectedCol && this.state.selectedCol.label === 'DUPLICATE') || (this.state.selectedCategory && this.state.selectedCategory.value < 11))) ?
                <p className="total_error_counter" id="total-error-counter">Total Records with Errors/Warnings: {this.state.totalErrors}/{this.state.attributeTotalErrors}</p> :
                <p className="total_error_counter" id="total-error-counter">Total Records with Errors/Warnings: {this.state.totalErrors}</p>}
              </div>
              <div>
                {this.state.selectedCategory && this.state.selectedCategory.value > 10 && this.state.totalErrors === 50 ?
                  <p>Total number of transformation for the selected column may be more than 50</p> : null
                }
              </div>
            </div>
          </div>
          <div hidden={this.state.hideGrid}>
            <ReactDataGrid id="react-data-grid"
              enableCellSelect={true}
              enableCellAutoFocus={true}
              columns={this.state.columns}
              rowGetter={this.rowGetter}
              rowsCount={this.rowsCount()}
              onGridRowsUpdated={this.handleGridRowsUpdated}
              onGridSort={this.handleGridSort}
              rowRenderer={RowRenderer}
              minHeight={this.rowsCount()<50?this.rowsCount()*35+70:500}
              rowSelection={this.getRowSelection()}
            />
          </div>
        </div>
        <div>
          <InlineEditingSaveBtn
            apiAuthHeaders={this.props.apiAuthHeaders}
            editedStagingData={this.state.data}
            deletedStagingData={this.state.deletedRecords}
            disableSaveBtn={this.state.disableSaveBtn}
            request={this.props.requestData}
            changeSaveButtonState={this.changeSaveButtonState}
          />
        </div>
      </div>
    )

  }
}

export default InlineEditingGridData
